<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container
    fluid
    grid-list-md
  >
    <v-layout
      row
      wrap
    >
      <v-flex xs12>
        <v-layout row>
          <v-flex xs12>
            <v-card>
              <card-toolbar title="Gönderilen Gönderici Adları"></card-toolbar>
              <v-card-text>
                <v-flex>
                  <v-btn color="primary" @click="$trigger('set:sender-create')">Yeni Gönderici Ekle</v-btn>
                </v-flex>
                <v-data-table
                  :sort-by="['status']"
                  :headers="headers"
                  :items="data"
                >
                  <template v-slot:item.status="{ item }">
                    <v-chip :class="{
                      success: item.status === '1',
                      warning: item.status === '2'
                    }">
                      <span v-if="item.status === '1'">Onaylandı!</span>
                      <span v-else-if="item.status === '2'">Reddedildi</span>
                      <span v-else>Beklemede</span>
                    </v-chip>
                  </template>
                  <no-data-available />
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
      <sender-create />
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import NoDataAvailable from '../../Components/Datatables/NoDataAvailable.vue';
import SenderCreate from '../../Components/SenderCreate/SenderCreate.vue';
import CardToolbar from '../../Components/CardToolbar.vue';

export default {
  name: 'Index',
  data: () => ({
    headers: [
      { text: 'Gönderici Adı', value: 'sender', align: 'left' },
      { text: 'Durum', value: 'status' },
    ],
    data: [],
  }),
  components: {
    CardToolbar,
    SenderCreate,
    NoDataAvailable,
  },
  methods: {
    ...mapActions({ send: 'sendBackend' }),
    loadSenders() {
      const url = 'show/senders';
      this.send({ route: url }).then((res) => {
        this.data = res.data.data;
      });
    },
  },
  created() {
    this.loadSenders();
  },
  events: {
    'load:senders': 'loadSenders',
  },
};
</script>
